import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 20,
    border: "1px solid transparent",
    boxShadow: "none",
    backgroundColor: "transparent",
    height: "100%",
    [theme.breakpoints.down("xs")]: {
      marginBottom: 16
    },
    [theme.breakpoints.up("md")]: {
      marginBottom: 0
    }
  },
  datesList: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    flexGrow: 1,
    transform: "translateZ(0)"
  },
  date: {
    width: "13%",
    height: "auto",
    borderRadius: 2,
    minWidth: "13%",
    maxWidth: "13%",
    marginTop: 12,
    marginRight: "calc(100% / 7 - 13%)",
    "&:nth-child(7n)": {
      marginRight: 0
    },
    [theme.breakpoints.down("xs")]: {
      maxHeight: 77,
      marginTop: 10
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 16
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: 16
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: 11
    }
  },
  monthGroup: {
    display: "flex",
    flexWrap: "nowrap",
    transform: "translateZ(0)",
    position: "relative"
  },
  calendarDivider: {
    marginRight: 8
  }
}));
